module.exports = __webpack_public_path__ + "media/images/coupon/enroll-1aa42612c1ba5fe5ff5b1db221b03726.png";